import { ResumeMonthlyModel } from "./resumeMonthly.model";

export class ResumeV2Model {
  // ************************* Incomes/Ingresos
  incomes: ResumeMonthlyModel[];
  incomesPaid: ResumeMonthlyModel[];
  incomesUnPaid: ResumeMonthlyModel[];

  incomesIva: ResumeMonthlyModel[];
  incomesIgic: ResumeMonthlyModel[];


  // ************************* Expenses
  expenses: ResumeMonthlyModel[];
  expensesPaid: ResumeMonthlyModel[];
  expensesUnPaid: ResumeMonthlyModel[];

  expensesIva: ResumeMonthlyModel[];
  expensesIgic: ResumeMonthlyModel[];
  expensesIrpf: ResumeMonthlyModel[];
  expensesIgicImport: ResumeMonthlyModel[]; // IGIC Importación

  // ************************* Inversiones

  investmentIgic: ResumeMonthlyModel[];

  // ************************* Subvenciones

  subventions: ResumeMonthlyModel[];

  //*******************************Proyectos */

  ticketsPaid: ResumeMonthlyModel[] = [];
  ticketsPending: ResumeMonthlyModel[] = [];

  constructor() { }
}
